export default {
  zh: {
    betDesc: "押注说明",
    propsDesc: "道具说明",

    title: "1、怎么参与?",
    content: `选择金币数值，再点击玩家头像即可押注。对应玩家押注值将增加。<br/>1个用户在1场对局中最多可押注<span style="color:#fff">100k</span>金币`,
    modTitle1: "2个棋子模式：",
    modContent1: "当有一个玩家进入1颗棋子时，将关闭押注入口。",
    modTitle2: "4个棋子模式：",
    modContent2: "当有一个玩法家进入3颗棋子时，将关闭押注入口。",
    quickTitle: "快速模式：",
    quickContent: `开局<span style="color:#fff"> {120S} </span>后停止押注`,
    title2: "2、押注规则",
    rule2content: `获胜玩家将获得其他玩家“被押注的金币总数”的<span style="color:#fff">5%</span>。`,
    rule2content2: `押注获胜者将退回押注获胜玩家的全部金币，并与其他“押注获胜者”按押注比例获得“其他玩家被押注的金币总数”的<span style="color:#fff">95%</span>。`,

    props1Title: "1、【重摇】",
    props1Conten1: `选择玩家，点击<span style="color:#fff">【发送】</span>，该玩家下一轮的第一个骰子为<span style="color:#fff">【重摇】</span>`,
    props1Conten2: `一场游戏中1个玩家仅可使用<span style="color:#fff"> {10} </span>次`,

    props2Title: "2、【烟雾弹】",
    props2Conten1: `选择玩家，点击<span style="color:#fff">【发送】</span>，指定玩家的押注的数据将无法查看，仅发送的用户可查看。`,
    props2Conten2: `烟雾弹有效时间为：<span style="color:#fff">1min</span>`,
    props2Conten3: `一场游戏中1个玩家仅可被发送<span style="color:#fff"> {10} </span>次`,
  },
  en: {
    betDesc: "Betting Description",
    propsDesc: "Props Description",

    title: "1. How to participate?",
    content: `
    Select the value of the gold coin, and then click the player's avatar to bet. The corresponding player bet value will increase.
    <br/>
    One user can bet up to <span style="color:#fff">100k</span> coins in one match.`,

    modTitle1: "2 pieces mode：",
    modContent1: "When a player enters 1 piece, the betting port will be closed.",
    modTitle2: "4 pieces mode：",
    modContent2: "When a player enters 3 pieces, the betting port will be closed.",
    quickTitle: "Quick mode：",
    quickContent: `Stop betting after the opening <span style="color:#fff"> 120S </span>`,

    title2: "2. Betting Rules",
    rule2content: `The winning player will receive <span style="color:#fff">5%</span> of the total amount of coins wagered by other players`,
    rule2content2: `The winner of the bet will return all the gold coins of the betting winning player, and get <span style="color:#fff">95%</span> of the total bet gold coins of other players in proportion to the betting`,

    props1Title: "1、ReRoll",
    props1Conten1: `Select a player, click <span style="color:#fff">Send</span> , the first dice of the player's next round will be <span style="color:#fff">ReRoll</span>`,
    props1Conten2: `One player can only use it <span style="color:#fff"> 10 </span> times in one game`,

    props2Title: "2、smoke bomb",
    props2Conten1: `Select a player and click <span style="color:#fff">Send</span> , the betting data of the specified player will not be viewable, only the sending user can view it.`,
    props2Conten2: `The effective time of the smoke bomb is <span style="color:#fff">1min</span>`,
    props2Conten3: `A player can only be sent <span style="color:#fff"> 10 </span> times in a game`,
  },
}


// WEBPACK FOOTER //
// src/pages/ludo/gamerule/lang.js